import { render, staticRenderFns } from "./AudioRecorder.vue?vue&type=template&id=461ee717&"
import script from "./AudioRecorder.vue?vue&type=script&lang=js&"
export * from "./AudioRecorder.vue?vue&type=script&lang=js&"
import style0 from "./AudioRecorder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports